// let httpAddressdev = `//user-sdkv2-test.dhsf.xqhuyu.com`
let httpAddressdev = `//user-sdkv2.dhsf.xqhuyu.com`
// let httpAddress = `//user-sdkv2-test.ppp996.hqyxkj.cn`
let httpAddress = `//sdkv2.dhsf.xqhuyu.com`
// let httpUser = `//user-sdkv2-test.ppp996.hqyxkj.cn`
let httpUser = `//user-sdkv2.dhsf.xqhuyu.com`
let httpUsernew = `//prom-sdkv2.dhsf.xqhuyu.com`
// let httpUsernew = `//prom-sdkv2-test.ppp996.hqyxkj.cn`
let httpPay= `//pay-sdkv2.dhsf.xqhuyu.com`
// let httpAddress = `http://apiv2.dev.fmej0.com`
let baseUrl = `/api`
let payUrl = ``
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
	httpAddress = ``;  // 请求域名
	// httpPay = ``;  // 请求域名
	payUrl = `/sdkv2`
	// baseUrl = `/api`
}
export default {
	user: {
		// 登出
		logout: `${baseUrl}/user/logout`,
		// 获取用户信息
		getInfo: `${baseUrl}/user/getUserInfo`,
		// 获取菜单
		getMenu: `${baseUrl}/user/getMenu`,
		// 获取用户信息
		getUserInfo: `${baseUrl}/getUserInfo`,
		// 登录
		login: `${httpUser}${baseUrl}/user/login`,
		// login: `${httpUser}${baseUrl}/user/loadSdkData`,
		// 获取短信接口
		sendsms: `${httpUser}${baseUrl}/user/sendSms`,
		// 手机验证码登陆
		phoneLogin: `${httpAddress}${baseUrl}/user/phoneLogin`,
		// 用户实名认证
		identification: `${httpAddress}${baseUrl}/user/identification`,
		// 用户名密码注册
		reg: `${httpUser}${baseUrl}/user/reg`,
		// 客服
		getKfQqGroup: `${httpAddress}${baseUrl}/user/getKfQqGroup`,
		// 游戏隐私协议
		protocol: `${httpAddress}${baseUrl}/user/protocol`,
		// 盒子登录
		tokenLogin: `${httpUser}${baseUrl}/user/token_login`,
		// 巨量激活上报
		ActivateJlReport: `${httpUsernew}${baseUrl}/promotion/activateJlReport`,
		// 查看按钮情况
		loadSdkData: `${httpUser}${baseUrl}/user/loadSdkData`,
		// loadSdkData: `//user-sdkv2-dev.dhsf.xqhuyu.com/api/user/loadSdkData`,
	},
	forget: {
		// 忘记密码查找账户
		forgetPassword: `${httpAddress}${baseUrl}/user/forgetPassword`,
		// 验证手机验证码
		verifyCode: `${httpAddress}${baseUrl}/user/verifyCode`,
		// 忘记密码-修改密码
		phoneEditPassword: `${httpAddress}${baseUrl}/user/phoneEditPassword`,
		// 手机验证码修改绑定手机
		editBindingPhone: `${httpAddress}${baseUrl}/user/editBindingPhone`,
		// 登录状态下绑定手机
		bindPhone: `${httpAddress}${baseUrl}/user/bindPhone`,
		// 修改密码
		changePwd: `${httpAddress}${baseUrl}/user/changePwd`,
	},
	pay: {
		// 支付接口
		orderPlace: `${httpPay}${baseUrl}/pay/orderPlace`,
		// 订单查询查询
		payResult: `${httpPay}${baseUrl}/pay/payResult`,
		// 获取支付扫码二维码
		getUserQrcode: `${httpPay}${baseUrl}/pay/getUserQrcode`,
		// 微信公众号支付
		wxjsapipay: `${httpPay}/api/paywx/getopenid`,
	}
}
